import React, { Component } from 'react';
import CSSModules from "react-css-modules";

import PageHeader from "../PageHeader";

import style from "./style.scss";

class BookingSuccess extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render(){

        return (
            <article styleName="section-content">

                <PageHeader title="Thank You" />

                <p styleName="success-message">
                    Your training course booking was successfully sent and you will
                    receive a confirmation email shortly.
                </p>

            </article>
        )
    }
}

export default CSSModules(BookingSuccess, style);


// WEBPACK FOOTER //
// ./components/BookingSuccess/index.js